<template>
  <div id="supplier">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl" @navSearchContent = "navSearchContent" @conditionsSearchContent = "conditionsSearchContent" :coordinationSupplierAuthFlag="coordinationSupplierAuthFlag" :coordinationSystemAuthFlag="coordinationSystemAuthFlag" :supplierManagerAuthFlag="supplierManagerAuthFlag"> </v-topBar>
    <v-notificationTop :noticeInfo="noticeInfo" v-show="showNoticeInfo"></v-notificationTop>

    <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl" @navSearchContent = "navSearchContent" @navChangeBussinessType="navChangeBussinessType"
              @pagePosition="pagePosition"></v-header>
    <div class="supplierCon">
      <v-purchaserBanner :loading="loading" :bannerInfo='bannerInfo' :ratationTime="ratationTime"></v-purchaserBanner>
      <!--<v-dataCount :paramInfo="paramInfo"></v-dataCount>-->
<!--      <v-supplierLogged :supplierMenuList="supplierMenuList" :qualificationsFileUrl="qualificationsFileUrl" :viewMessageUrl="viewMessageUrl" :companyConfigUrl="companyConfigUrl" :coordinationSupplierAuthFlag="coordinationSupplierAuthFlag" class="hidden-xs hidden-sm"></v-supplierLogged>-->
    </div>
    <v-dynamicNews :newsInfo="newsInfo" @tranDate="changeViewNumber"></v-dynamicNews>
    <!-- <v-dynamicNews :newsInfo=""></v-dynamicNews> -->
    <div class="supplierEntry" id="supplierEntry">
      <v-publiceTit :titleObj='titleObj'></v-publiceTit>
      <div class="searchSupplier">
        <div class="input-group input-group-lg">
          <input type="text" class="form-control"  aria-describedby="sizing-addon1" placeholder="请输入关键字" v-model="selectNotice" ref="noticeContent" @keyup.enter="searchContent()">
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" @click="searchContent(null)" >搜索</button>
          </span>
        </div>
        <!--<div v-if="placeholderSearch" class="input-group input-group-lg">-->
          <!--<input type="text" class="form-control"  aria-describedby="sizing-addon1" placeholder="请输入项目名称/内容/招标主体名称关键字" v-model="selectNotice" ref="noticeContent" @keyup.enter="searchContent()">-->
          <!--<span class="input-group-btn">-->
            <!--<button class="btn btn-default" type="button" @click="searchContent()" >搜索</button>-->
          <!--</span>-->
        <!--</div>-->
      </div><!-- /.row -->
      <div class="proCon" v-loading="sortLoading">
        <div class="tabTitle">
          <div class="mobileNavCon">
            <ul id="supplierEntryTab" class="nav nav-tabs">
              <li class="active">
                <a href="#tenderNnotice" data-toggle="tab" @click="changeBussinessType(2)">招标公告<div class="tabLine"></div></a>
              </li>
              <li >
                <a href="#xbj" data-toggle="tab" @click="changeBussinessType(1)">询报价<div class="tabLine"></div></a>
              </li>
              <li>
                <a href="#winTheBidding" data-toggle="tab" @click="changeBussinessType(3)">中标公示<div class="tabLine"></div></a>
              </li>
            </ul>
          </div>
          <div class="mobileClass hidden-sm hidden-md hidden-lg" v-show="projectAreaShow">
            <a data-toggle="modal" data-target="#classModal2" @click="showModal"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/filter_icon.png" alt=""></a>
            <div class="modal fade" id="classModal2" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="classCon clearfix">
                    <ul id="classTab2" class="nav nav-tabs">
                      <li class="active col-xs-6 col-sm-6">
                        <a href="#categoryList" @click="tabChange(true)" data-toggle="tab">类别</a>
                      </li>
                      <li class="col-xs-6 col-sm-6">
                        <a href="#projectArea" @click="tabChange(false)" data-toggle="tab">项目位置</a>
                      </li>
                    </ul>
                    <div class="tabCon">
                      <div id="classTabContent2" class="tab-content">
                        <div class="tab-pane fade in active" id="categoryList">
                          <el-radio-group v-model="categoryRadio">
                            <el-radio label="">全部</el-radio>
                            <el-radio label="000000" v-if="currencyFlag">通用</el-radio>
                            <el-radio label="INV0001" v-if="steelFlag">钢铁</el-radio>
                            <el-radio label="INV0002" v-if="landFlag">蜂巢</el-radio>
                          </el-radio-group>
                        </div>
                        <div class="tab-pane fade clearfix" id="projectArea">

                          <div class="areaList clearfix col-xs-3 col-sm-3">

                            <ul class="nav nav-tabs nav-stacked">
                              <li class="active">
                                <a href="#hotCities" data-toggle="tab">热门</a>
                              </li>
                              <li>
                                <a href="#eastChina" @click="mobileGetCity('310000')" data-toggle="tab">华东</a>
                              </li>
                              <li>
                                <a href="#northChina" @click="mobileGetCity('110000')" data-toggle="tab">华北</a>
                              </li>
                              <li>
                                <a href="#southWest" @click="mobileGetCity('500000')" data-toggle="tab">西南</a>
                              </li>
                              <li>
                                <a href="#northEast" @click="mobileGetCity('210000')" data-toggle="tab">东北</a>
                              </li>
                              <li>
                                <a href="#southChina" @click="mobileGetCity('440000')" data-toggle="tab">华南</a>
                              </li>
                              <li>
                                <a href="#northWest" @click="mobileGetCity('610000')" data-toggle="tab">西北</a>
                              </li>
                              <li>
                                <a href="#centralChina" @click="mobileGetCity('410000')" data-toggle="tab">华中</a>
                              </li>
                              <li>
                                <a href="#otherCity" data-toggle="tab">其他</a>
                              </li>
                            </ul>
                          </div>
                          <div class="tabCon col-xs-9 col-sm-9">
                            <div id="classTabContent3" class="tab-content">
                              <div class="tab-pane fade in active" id="hotCities">
                                <el-radio-group v-model="hotCity">
                                  <el-radio label="上海">上海</el-radio>
                                  <el-radio label="苏州">苏州</el-radio>
                                  <el-radio label="嘉兴">嘉兴</el-radio>
                                  <el-radio label="南通">南通</el-radio>
                                  <el-radio label="无锡">无锡</el-radio>
                                  <el-radio label="常州">常州</el-radio>
                                  <el-radio label="南京">南京</el-radio>
                                  <el-radio label="杭州">杭州</el-radio>
                                  <el-radio label="宁波">宁波</el-radio>
                                </el-radio-group>
                              </div>
                              <div class="tab-pane fade clearfix" id="eastChina">

                                <div class="provinceList col-xs-4 col-sm-4">
                                  <ul class="nav nav-tabs nav-stacked">
                                    <li class="active">
                                      <a href="#shEastChina" @click="mobileGetCity('310000')" data-toggle="tab">上海</a>
                                    </li>
                                    <li>
                                      <a href="#jsEastChina" @click="mobileGetCity('320000')" data-toggle="tab">江苏</a>
                                    </li>
                                    <li>
                                      <a href="#zjEastChina" @click="mobileGetCity('330000')" data-toggle="tab">浙江</a>
                                    </li>
                                    <li>
                                      <a href="#ahEastChina" @click="mobileGetCity('340000')" data-toggle="tab">安徽</a>
                                    </li>
                                    <li>
                                      <a href="#fjEastChina" @click="mobileGetCity('350000')" data-toggle="tab">福建</a>
                                    </li>
                                    <li>
                                      <a href="#jxEastChina" @click="mobileGetCity('360000')" data-toggle="tab">江西</a>
                                    </li>
                                    <li>
                                      <a href="#sdEastChina" @click="mobileGetCity('370000')" data-toggle="tab">山东</a>
                                    </li>
                                  </ul>
                                </div>
                                <div class="tabCon col-xs-8 col-sm-8">
                                  <div id="classTabContent4" class="tab-content">
                                    <div class="tab-pane fade in active" id="shEastChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="上海">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="jsEastChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="江苏">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="zjEastChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="浙江">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="ahEastChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="安徽">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="fjEastChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="福建">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="jxEastChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="江西">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="sdEastChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="山东">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--华北-->
                              <div class="tab-pane fade clearfix" id="northChina">

                                <div class="provinceList col-xs-4 col-sm-4">
                                  <ul class="nav nav-tabs nav-stacked">
                                    <li class="active">
                                      <a href="#bjNorthChina" @click="mobileGetCity('110000')" data-toggle="tab">北京</a>
                                    </li>
                                    <li>
                                      <a href="#tjNorthChina" @click="mobileGetCity('120000')" data-toggle="tab">天津</a>
                                    </li>
                                    <li>
                                      <a href="#hbNorthChina" @click="mobileGetCity('130000')" data-toggle="tab">河北</a>
                                    </li>
                                    <li>
                                      <a href="#sxNorthChina" @click="mobileGetCity('140000')" data-toggle="tab">山西</a>
                                    </li>
                                    <li>
                                      <a href="#nmgNorthChina" @click="mobileGetCity('150000')" data-toggle="tab">内蒙古</a>
                                    </li>
                                  </ul>
                                </div>
                                <div class="tabCon col-xs-8 col-sm-8">
                                  <div id="classTabContent5" class="tab-content">
                                    <div class="tab-pane fade in active" id="bjNorthChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="北京">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="tjNorthChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="天津">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="hbNorthChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="河北">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="sxNorthChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="山西">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="nmgNorthChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="内蒙古">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--西南-->
                              <div class="tab-pane fade clearfix" id="southWest">

                                <div class="provinceList col-xs-4 col-sm-4">
                                  <ul class="nav nav-tabs nav-stacked">
                                    <li class="active">
                                      <a href="#cqSouthWest" @click="mobileGetCity('500000')" data-toggle="tab">重庆</a>
                                    </li>
                                    <li>
                                      <a href="#gxSouthWest" @click="mobileGetCity('450000')" data-toggle="tab">广西</a>
                                    </li>
                                    <li>
                                      <a href="#scSouthWest" @click="mobileGetCity('510000')" data-toggle="tab">四川</a>
                                    </li>
                                    <li>
                                      <a href="#gzSouthWest" @click="mobileGetCity('520000')" data-toggle="tab">贵州</a>
                                    </li>
                                    <li>
                                      <a href="#ynSouthWest" @click="mobileGetCity('530000')" data-toggle="tab">云南</a>
                                    </li>
                                    <li>
                                      <a href="#xzSouthWest" @click="mobileGetCity('540000')" data-toggle="tab">西藏</a>
                                    </li>
                                  </ul>
                                </div>
                                <div class="tabCon col-xs-8 col-sm-8">
                                  <div id="classTabContent6" class="tab-content">
                                    <div class="tab-pane fade in active" id="cqSouthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="重庆">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="gxSouthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="广西">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="scSouthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="四川">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="gzSouthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="贵州">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="ynSouthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="云南">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="xzSouthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="西藏">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--东北-->
                              <div class="tab-pane fade clearfix" id="northEast">

                                <div class="provinceList col-xs-4 col-sm-4">
                                  <ul class="nav nav-tabs nav-stacked">
                                    <li class="active">
                                      <a href="#lnNorthEast" @click="mobileGetCity('210000')" data-toggle="tab">辽宁</a>
                                    </li>
                                    <li>
                                      <a href="#jlNorthEast" @click="mobileGetCity('220000')" data-toggle="tab">吉林</a>
                                    </li>
                                    <li>
                                      <a href="#hljNorthEast" @click="mobileGetCity('230000')" data-toggle="tab">黑龙江</a>
                                    </li>
                                  </ul>
                                </div>
                                <div class="tabCon col-xs-8 col-sm-8">
                                  <div id="classTabContent7" class="tab-content">
                                    <div class="tab-pane fade in active" id="lnNorthEast">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="辽宁">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="jlNorthEast">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="吉林">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="hljNorthEast">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="黑龙江">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--华南-->
                              <div class="tab-pane fade clearfix" id="southChina">

                                <div class="provinceList col-xs-4 col-sm-4">
                                  <ul class="nav nav-tabs nav-stacked">
                                    <li class="active">
                                      <a href="#gdSouthChina" @click="mobileGetCity('440000')" data-toggle="tab">广东</a>
                                    </li>
                                    <li>
                                      <a href="#hnSouthChina" @click="mobileGetCity('460000')" data-toggle="tab">海南</a>
                                    </li>
                                  </ul>
                                </div>
                                <div class="tabCon col-xs-8 col-sm-8">
                                  <div id="classTabContent8" class="tab-content">
                                    <div class="tab-pane fade in active" id="gdSouthChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="广东">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="hnSouthChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="海南">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--西北-->
                              <div class="tab-pane fade clearfix" id="northWest">

                                <div class="provinceList col-xs-4 col-sm-4">
                                  <ul class="nav nav-tabs nav-stacked">
                                    <li class="active">
                                      <a href="#sxNorthWest" @click="mobileGetCity('610000')" data-toggle="tab">陕西</a>
                                    </li>
                                    <li>
                                      <a href="#gsNorthWest" @click="mobileGetCity('620000')" data-toggle="tab">甘肃</a>
                                    </li>
                                    <li>
                                      <a href="#qhNorthWest" @click="mobileGetCity('630000')" data-toggle="tab">青海</a>
                                    </li>
                                    <li>
                                      <a href="#nxNorthWest" @click="mobileGetCity('640000')" data-toggle="tab">宁夏</a>
                                    </li>
                                    <li>
                                      <a href="#xjNorthWest" @click="mobileGetCity('650000')" data-toggle="tab">新疆</a>
                                    </li>
                                  </ul>
                                </div>
                                <div class="tabCon col-xs-8 col-sm-8">
                                  <div id="classTabContent9" class="tab-content">
                                    <div class="tab-pane fade in active" id="sxNorthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="陕西">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="gsNorthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="甘肃">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="qhNorthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="青海">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="nxNorthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="宁夏">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="xjNorthWest">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="新疆">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--华中-->
                              <div class="tab-pane fade clearfix" id="centralChina">

                                <div class="provinceList col-xs-4 col-sm-4">
                                  <ul class="nav nav-tabs nav-stacked">
                                    <li class="active">
                                      <a href="#hnCentralChina" @click="mobileGetCity('410000')" data-toggle="tab">河南</a>
                                    </li>
                                    <li>
                                      <a href="#hbCentralChina" @click="mobileGetCity('420000')" data-toggle="tab">湖北</a>
                                    </li>
                                    <li>
                                      <a href="#hunCentralChina" @click="mobileGetCity('430000')" data-toggle="tab">湖南</a>
                                    </li>
                                  </ul>
                                </div>
                                <div class="tabCon col-xs-8 col-sm-8">
                                  <div id="classTabContent11" class="tab-content">
                                    <div class="tab-pane fade in active" id="hnCentralChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="河南">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="hbCentralChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="湖北">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                    <div class="tab-pane fade" id="hunCentralChina">
                                      <el-radio-group v-model="hotCity">
                                        <el-radio label="湖南">全部</el-radio>
                                        <el-radio  v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                                      </el-radio-group>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--其他-->
                              <div class="tab-pane fade in active" id="otherCity">
                                <el-radio-group v-model="hotCity">
                                  <el-radio label="香港">香港</el-radio>
                                  <el-radio label="澳门">澳门</el-radio>
                                  <el-radio label="台湾">台湾</el-radio>
                                </el-radio-group>
                              </div>

                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="classBtn clearfix">
                    <el-button class="col-xs-6 col-sm-6" v-show="cancelShow" @click="cancelClass">取消</el-button>
                    <el-button class="col-xs-6 col-sm-6" v-show="!cancelShow" @click="resetClass">重置</el-button>
                    <el-button class="col-xs-6 col-sm-6" @click="confirmClass">确认</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mobileClass hidden-sm hidden-md hidden-lg" v-show="!projectAreaShow">
            <a data-toggle="modal" data-target="#classModal3" @click="showModal"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/filter_icon.png" alt=""></a>
            <div class="modal fade" id="classModal3" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="classCon clearfix">
                    <ul id="classTab3" class="nav nav-tabs nav-stacked col-xs-3 col-sm-3">
                      <li class="active">
                        <a href="#categoryList2" data-toggle="tab">类别</a>
                      </li>
                    </ul>
                    <div class="tabCon col-xs-9 col-sm-9">
                      <div id="classTabContent33" class="tab-content">
                        <div class="tab-pane fade in active" id="categoryList2">
                          <el-radio-group v-model="categoryRadio">
                            <el-radio label="">全部</el-radio>
                            <el-radio label="000000" v-if="currencyFlag">通用</el-radio>
                            <el-radio label="INV0001" v-if="steelFlag">钢铁</el-radio>
                            <el-radio label="INV0002" v-if="landFlag">蜂巢</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="classBtn clearfix">
                    <el-button class="col-xs-6 col-sm-6" @click="cancelClass">取消</el-button>
                    <el-button class="col-xs-6 col-sm-6" @click="confirmClass">确认</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!--pc筛选条件-->
        <div class="cityFilter hidden-xs clearfix" v-if="hotCity">
          <span class="conditionsClass pull-left">筛选条件：</span>
          <el-tag size="medium" color="transparent" closable @close="cityClose">城市：{{hotCity}}</el-tag>
          <el-button size="mini" class="pull-right" @click="cityClose">重置</el-button>
        </div>
        <div class="screeningConditions hidden-xs">
          <div class="conditionsCon clearfix">
            <span class="conditionsClass pull-left">类别：</span>
            <ul class="clearfix conditionsList">
              <li class="active pull-left" @click="searchBussiness('','',$event, '全部')">全部</li>
              <li class="pull-left" @click="searchBussiness('','000000',$event, '通用')" v-if="currencyFlag">通用</li>
              <li class="pull-left" @click="searchBussiness('','INV0001',$event, '钢铁')" v-if="steelFlag">钢铁</li>
              <li class="pull-left" @click="searchBussiness('','INV0002',$event, '蜂巢')" v-if="landFlag">蜂巢</li>
              <li class="pull-left" @click="searchBussiness('','INV0003',$event, '旅文')" v-if="travelFlag">旅文</li>
            </ul>
          </div>
          <div class="conditionsCon" style="height: 7px;margin-top: 0px;" v-show="!projectAreaShow"></div>
          <div class="conditionsCon positionCon clearfix" v-show="projectAreaShow">
            <span class="conditionsClass pull-left">项目位置：</span>
            <div class="clearfix conditionsList" v-show="hotShow">
              <span>热门城市></span>
              <el-radio-group v-model="hotCity" @change="getHotCity">
                <el-radio label="上海">上海</el-radio>
                <el-radio label="苏州">苏州</el-radio>
                <el-radio label="嘉兴">嘉兴</el-radio>
                <el-radio label="南通">南通</el-radio>
                <el-radio label="无锡">无锡</el-radio>
                <el-radio label="常州">常州</el-radio>
                <el-radio label="南京">南京</el-radio>
                <el-radio label="杭州">杭州</el-radio>
                <el-radio label="宁波">宁波</el-radio>
                <!--<el-radio label="310100">上海</el-radio>-->
                <!--<el-radio label="320500">苏州</el-radio>-->
                <!--<el-radio label="330400">嘉兴</el-radio>-->
                <!--<el-radio label="320600">南通</el-radio>-->
                <!--<el-radio label="320200">无锡</el-radio>-->
                <!--<el-radio label="320400">常州</el-radio>-->
                <!--<el-radio label="320100">南京</el-radio>-->
                <!--<el-radio label="330100">杭州</el-radio>-->
                <!--<el-radio label="330200">宁波</el-radio>-->
              </el-radio-group>
            </div>
            <ul class="clearfix conditionsList positionList" v-show="!hotShow">
              <li class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <span class="pull-left">华东></span>
                <el-radio-group v-model="hotCity" @change="getHotCity">
                  <el-popover
                    @show="getPositionCity(310000)"
                    popper-class="positionPopover"
                    ref="popover31"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(320000)"
                    popper-class="positionPopover"
                    ref="popover32"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(330000)"
                    popper-class="positionPopover"
                    ref="popover33"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(340000)"
                    popper-class="positionPopover"
                    ref="popover34"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(350000)"
                    popper-class="positionPopover"
                    ref="popover35"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(360000)"
                    popper-class="positionPopover"
                    ref="popover36"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(370000)"
                    popper-class="positionPopover"
                    ref="popover37"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-radio label="上海" v-popover:popover31>上海</el-radio>
                  <el-radio label="江苏" v-popover:popover32>江苏</el-radio>
                  <el-radio label="浙江" v-popover:popover33>浙江</el-radio>
                  <el-radio label="安徽" v-popover:popover34>安徽</el-radio>
                  <el-radio label="福建" v-popover:popover35>福建</el-radio>
                  <el-radio label="江西" v-popover:popover36>江西</el-radio>
                  <el-radio label="山东" v-popover:popover37>山东</el-radio>
                  <!--<el-radio label="310000" v-popover:popover31>上海</el-radio>-->
                  <!--<el-radio label="320000" v-popover:popover32>江苏</el-radio>-->
                  <!--<el-radio label="330000" v-popover:popover33>浙江</el-radio>-->
                  <!--<el-radio label="340000" v-popover:popover34>安徽</el-radio>-->
                  <!--<el-radio label="350000" v-popover:popover35>福建</el-radio>-->
                  <!--<el-radio label="360000" v-popover:popover36>江西</el-radio>-->
                  <!--<el-radio label="370000" v-popover:popover37>山东</el-radio>-->
                </el-radio-group>
              </li>
              <li class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <span class="pull-left">华北></span>
                <el-radio-group v-model="hotCity" @change="getHotCity">
                  <el-popover
                    @show="getPositionCity(110000)"
                    popper-class="positionPopover"
                    ref="popover11"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(120000)"
                    popper-class="positionPopover"
                    ref="popover12"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(130000)"
                    popper-class="positionPopover"
                    ref="popover13"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(140000)"
                    popper-class="positionPopover"
                    ref="popover14"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(150000)"
                    popper-class="positionPopover"
                    ref="popover15"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-radio label="北京" v-popover:popover11>北京</el-radio>
                  <el-radio label="天津" v-popover:popover12>天津 </el-radio>
                  <el-radio label="河北" v-popover:popover13>河北</el-radio>
                  <el-radio label="山西" v-popover:popover14>山西</el-radio>
                  <el-radio label="内蒙古" v-popover:popover15>内蒙古</el-radio>
                  <!--<el-radio label="110000" v-popover:popover11>北京</el-radio>-->
                  <!--<el-radio label="120000" v-popover:popover12>天津 </el-radio>-->
                  <!--<el-radio label="130000" v-popover:popover13>河北</el-radio>-->
                  <!--<el-radio label="140000" v-popover:popover14>山西</el-radio>-->
                  <!--<el-radio label="150000" v-popover:popover15>内蒙古</el-radio>-->
                </el-radio-group>
              </li>
              <li class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <span class="pull-left">西南></span>
                <el-radio-group v-model="hotCity" @change="getHotCity">
                  <el-popover
                    @show="getPositionCity(500000)"
                    popper-class="positionPopover"
                    ref="popover50"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(450000)"
                    popper-class="positionPopover"
                    ref="popover45"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(510000)"
                    popper-class="positionPopover"
                    ref="popover51"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(520000)"
                    popper-class="positionPopover"
                    ref="popover52"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(530000)"
                    popper-class="positionPopover"
                    ref="popover53"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(540000)"
                    popper-class="positionPopover"
                    ref="popover54"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-radio label="重庆" v-popover:popover50>重庆</el-radio>
                  <el-radio label="广西" v-popover:popover45>广西</el-radio>
                  <el-radio label="四川" v-popover:popover51>四川</el-radio>
                  <el-radio label="贵州" v-popover:popover52>贵州</el-radio>
                  <el-radio label="云南" v-popover:popover53>云南</el-radio>
                  <el-radio label="西藏" v-popover:popover54>西藏</el-radio>
                  <!--<el-radio label="500000" v-popover:popover50>重庆</el-radio>-->
                  <!--<el-radio label="450000" v-popover:popover45>广西</el-radio>-->
                  <!--<el-radio label="510000" v-popover:popover51>四川</el-radio>-->
                  <!--<el-radio label="520000" v-popover:popover52>贵州</el-radio>-->
                  <!--<el-radio label="530000" v-popover:popover53>云南</el-radio>-->
                  <!--<el-radio label="540000" v-popover:popover54>西藏</el-radio>-->
                </el-radio-group>
              </li>
              <li class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <span class="pull-left">东北></span>
                <el-radio-group v-model="hotCity" @change="getHotCity">
                  <el-popover
                    @show="getPositionCity(210000)"
                    popper-class="positionPopover"
                    ref="popover21"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(220000)"
                    popper-class="positionPopover"
                    ref="popover22"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(230000)"
                    popper-class="positionPopover"
                    ref="popover23"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-radio label="辽宁" v-popover:popover21>辽宁</el-radio>
                  <el-radio label="吉林" v-popover:popover22>吉林</el-radio>
                  <el-radio label="黑龙江" v-popover:popover23>黑龙江</el-radio>
                  <!--<el-radio label="210000" v-popover:popover21>辽宁</el-radio>-->
                  <!--<el-radio label="220000" v-popover:popover22>吉林</el-radio>-->
                  <!--<el-radio label="230000" v-popover:popover23>黑龙江</el-radio>-->
                </el-radio-group>
              </li>
              <li class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <span class="pull-left">华南></span>
                <el-radio-group v-model="hotCity" @change="getHotCity">
                  <el-popover
                    @show="getPositionCity(440000)"
                    popper-class="positionPopover"
                    ref="popover44"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(460000)"
                    popper-class="positionPopover"
                    ref="popover46"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-radio label="广东" v-popover:popover44>广东</el-radio>
                  <el-radio label="海南" v-popover:popover46>海南</el-radio>
                  <!--<el-radio label="440000" v-popover:popover44>广东</el-radio>-->
                  <!--<el-radio label="460000" v-popover:popover46>海南</el-radio>-->
                </el-radio-group>
              </li>
              <li class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <span class="pull-left">西北></span>
                <el-radio-group v-model="hotCity" @change="getHotCity">
                  <el-popover
                    @show="getPositionCity(610000)"
                    popper-class="positionPopover"
                    ref="popover61"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(620000)"
                    popper-class="positionPopover"
                    ref="popover62"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(630000)"
                    popper-class="positionPopover"
                    ref="popover63"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(640000)"
                    popper-class="positionPopover"
                    ref="popover64"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(650000)"
                    popper-class="positionPopover"
                    ref="popover65"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-radio label="陕西" v-popover:popover61>陕西</el-radio>
                  <el-radio label="甘肃" v-popover:popover62>甘肃</el-radio>
                  <el-radio label="青海" v-popover:popover63>青海</el-radio>
                  <el-radio label="宁夏" v-popover:popover64>宁夏</el-radio>
                  <el-radio label="新疆" v-popover:popover65>新疆</el-radio>
                  <!--<el-radio label="610000" v-popover:popover61>陕西</el-radio>-->
                  <!--<el-radio label="620000" v-popover:popover62>甘肃</el-radio>-->
                  <!--<el-radio label="630000" v-popover:popover63>青海</el-radio>-->
                  <!--<el-radio label="640000" v-popover:popover64>宁夏</el-radio>-->
                  <!--<el-radio label="650000" v-popover:popover65>新疆</el-radio>-->
                </el-radio-group>
              </li>
              <li class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <span class="pull-left">华中></span>
                <el-radio-group v-model="hotCity" @change="getHotCity">
                  <el-popover
                    @show="getPositionCity(410000)"
                    popper-class="positionPopover"
                    ref="popover41"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(420000)"
                    popper-class="positionPopover"
                    ref="popover42"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-popover
                    @show="getPositionCity(430000)"
                    popper-class="positionPopover"
                    ref="popover43"
                    :visible-arrow="false"
                    placement="bottom-start"
                    width="400"
                    :open-delay="260"
                    trigger="hover">
                    <el-radio-group v-model="hotCity" @change="getHotCity">
                      <el-radio v-for="item in cities" :label="item.cityName" :key="item.cityCode">{{item.cityName}}</el-radio>
                    </el-radio-group>
                  </el-popover>
                  <el-radio label="河南" v-popover:popover41>河南</el-radio>
                  <el-radio label="湖北" v-popover:popover42>湖北</el-radio>
                  <el-radio label="湖南" v-popover:popover43>湖南</el-radio>
                  <!--<el-radio label="410000" v-popover:popover41>河南</el-radio>-->
                  <!--<el-radio label="420000" v-popover:popover42>湖北</el-radio>-->
                  <!--<el-radio label="430000" v-popover:popover43>湖南</el-radio>-->
                </el-radio-group>
              </li>
              <li class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <span class="pull-left">其他></span>
                <el-radio-group v-model="hotCity" @change="getHotCity">
                  <el-radio label="香港">香港</el-radio>
                  <el-radio label="澳门">澳门</el-radio>
                  <el-radio label="台湾">台湾</el-radio>
                  <!--<el-radio label="810000">香港</el-radio>-->
                  <!--<el-radio label="820000">澳门</el-radio>-->
                  <!--<el-radio label="710000">台湾</el-radio>-->
                </el-radio-group>
              </li>
            </ul>
            <a class="moreProBtn" @click="moreCity" v-show="hotShow">更多</a>
            <a class="moreProBtn" @click="moreCityHide" v-show="!hotShow">收起</a>
          </div>
          <div class="conditionsCon clearfix" v-show="projectAreaShow">
            <span class="conditionsClass pull-left">排序：</span>
            <ul class="clearfix conditionsList">
              <span class="cursor-pointer" @click="sortList('publishTime')">
                <span :class="{'active-sort-txt': publishTime !== null}">发布时间</span>
                <i class="sort-icon-normal" v-show="publishTime === null"></i>
                <i class="sort-icon-down" v-show="publishTime === true"></i>
                <i class="sort-icon-up" v-if="publishTime === false"></i>
              </span>
              <span style="padding-left: 6px;" class="cursor-pointer" @click="sortList('signEndTime')">
                <span :class="{'active-sort-txt': signEndTime !== null}">截止时间</span>
                <i class="sort-icon-normal" v-show="signEndTime === null"></i>
                <i class="sort-icon-down" v-show="signEndTime === true"></i>
                <i class="sort-icon-up" v-if="signEndTime === false"></i>
              </span>
            </ul>
          </div>
        </div>
        <div class="reminder hidden-xs" v-if="currentSourceType == 'INV0003'">
          <p>温馨提示：此模块为复星旅文集团在明源系统发布的公告，如须报名或查看项目进度，请至明源系统<a class="reminderLink" href="http://ep.fosunholiday.com/" target="_blank">（http://ep.fosunholiday.com/）</a>注册/登录进行操作。</p>
        </div>
        <!--pc筛选条件end-->
        <div class="tabCon">
          <div id="businessTabContent" class="tab-content">
             <div class="clearfix tabConBox tab-pane fade in active" id="tenderNnotice">
              <v-tenderNoticeList :currentSourceType="currentSourceType"
                                  :businessList="tenderBusinessList"
                                  :viewBussinessUrl="viewBussinessUrl"
                                  :customerPageUrl="customerPageUrl"
                                  :tenderLoad="tenderLoad"
                                  :keySearch="keySearch"
                                  :searchResult="searchResult"
                                  :nodata="noData"
                                  :reminderShow="reminderShow"
                                  :sensorsInfo="{
                                    currentPageTender,
                                    sensorsCurrentSourceName
                                  }">
              </v-tenderNoticeList>
               <div v-show="!searchResult && !noData">
                <button v-show="!lineShow" type="button" class="btn btn-default btn-lg hidden-sm hidden-md hidden-lg" @click="moreChangeTender">MORE</button>
                 <p class="lineCon" v-show="lineShow">
                   <span class="line"></span>
                   <el-button type="text" class="hidden-sm hidden-md hidden-lg" disabled>我也是有底线的</el-button>
                   <span class="line"></span>
                 </p>
               </div>
              <v-pagination v-show="!searchResult && !noData" class="hidden-xs" :total='tenderBusinessTotal' :display='9' :current-page='currentPageTender' @pagechange="pagechangeTender"></v-pagination>
            </div>
            <div class="clearfix tabConBox tab-pane fade " id="xbj">
              <v-businessList :businessList="inquiryBusinessList" :viewInquiryUrl="viewInquiryUrl"  :customerPageUrl="customerPageUrl" :tenderLoad="tenderLoad" :keySearch="keySearch" :searchResult="searchResult" :nodata="noData"></v-businessList>
              <div v-show="!searchResult && !noData">
                <button v-show="!lineShow" type="button" class="btn btn-default btn-lg hidden-sm hidden-md hidden-lg" @click="moreChangeInquiry">MORE</button>
                <p class="lineCon" v-show="lineShow">
                  <span class="line"></span>
                  <el-button type="text" class="hidden-sm hidden-md hidden-lg" disabled>我也是有底线的</el-button>
                  <span class="line"></span>
                </p>
              </div>
              <v-pagination v-show="!searchResult && !noData" class="hidden-xs" :total='inquiryBusinessTotal' :display='9' :current-page='currentPageInquiry' @pagechange="pagechangeInquiry"></v-pagination>
            </div>
            <div class="clearfix tabConBox tab-pane fade" id="winTheBidding">
              <v-winBiddingList :winBiddingList="winBiddingList" :viewBussinessUrl="viewBussinessUrl" :tenderLoad="tenderLoad" :keySearch="keySearch" :searchResult="searchResult" :nodata="noData" :reminderShow="reminderShow"></v-winBiddingList>
              <div v-show="!searchResult && !noData">
                <button v-show="!lineShow" type="button" class="btn btn-default btn-lg hidden-sm hidden-md hidden-lg" @click="moreChangeWinning">MORE</button>
                <p class="lineCon" v-show="lineShow">
                  <span class="line"></span>
                  <el-button type="text" class="hidden-sm hidden-md hidden-lg" disabled>我也是有底线的</el-button>
                  <span class="line"></span>
                </p>
              </div>
              <v-pagination v-show="!searchResult && !noData" class="hidden-xs" :total='winBiddingTotal' :display='10' :current-page='currentPageWin' @pagechange="pagechangeWinning"></v-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-enterpriseList></v-enterpriseList>
    <v-footer :webConfigInfo='webConfigInfo' :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
    <privacy-policy :isShow="visibleShow" @closed="closePrivacyPolicyDialog"></privacy-policy>
<!--  2020满意度调查  -->
<!--    <el-dialog-->
<!--      custom-class="questionnaire hidden-xs hidden-sm"-->
<!--      title=""-->
<!--      :modal-append-to-body="false"-->
<!--      :close-on-click-modal="false"-->
<!--      :close-on-press-escape="false"-->
<!--      :show-close="false"-->
<!--      :visible.sync="surveyVisible">-->
<!--      <p v-if="userInfo" class="userName">尊敬的{{userInfo.trueName}}：</p>-->
<!--      <p style="text-indent: 24px;">感谢您一直以来对一链网的支持！</p>-->
<!--      <p style="text-indent: 24px;">为后续给您提供更优质的服务，现诚挚地邀请您抽出【2分钟】时间，填写2020年上半年一链网供应商用户满意度调研问卷。此次问卷调研均为匿名形式，不会透露任何信息；该调研数据仅用于一链网进行用户满意度分析使用。感谢您的配合与支持！</p>-->
<!--      <span class="questionBtn" style="display:block;text-align: center;">-->
<!--        <el-button type="primary" @click="surveyDialogFn(true)">现在去填写</el-button>-->
<!--        <el-button @click="surveyFn">以后再说</el-button>-->
<!--      </span>-->
<!--      <div class="serverCon clearfix">-->
<!--        <div class="pull-left">-->
<!--          <h5>关注一链网服务号，随时掌握以下动态：</h5>-->
<!--          <ul>-->
<!--            <li>1､最新招标项目</li>-->
<!--            <li>2､采购小知识</li>-->
<!--            <li>3､优质采购商推荐</li>-->
<!--            <li>4､最新活动通知</li>-->
<!--          </ul>-->
<!--        </div>-->
<!--        <div class="pull-right">-->
<!--          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/server_erwm.png" alt="">-->
<!--          <p style="font-size: 12px;color: #A8ACB2;line-height: 16px;text-align: center;margin-top: 5px;">打开微信扫一扫</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-dialog>-->

    <!--  运营活动领取dialog  -->
    <v-checkinReceiveDialog
            :receiveDialogVisible="receiveDialogVisible"
            :userInfo="userInfo"
            @closeReceiveDialog="closeReceiveDialog">
    </v-checkinReceiveDialog>
  </div>
</template>
<script>
import header from '@/components/v-header/header'
import purchaserBanner from '@/components/purchaserBanner'
import dataCount from '@/components/data-count'
import supplierLogged from '@/components/supplierLogged'
import dynamicNews from '@/components/dynamicNews'
import topBar from '@/components/topBar'
import publiceTit from '@/components/publiceTit'
import businessList from '@/components/businessList'
import tenderNoticeList from '@/components/tenderNoticeList'
import winBiddingList from '@/components/winBiddingList'
import enterpriseList from '@/components/enterpriseList'
import footer from '@/components/v-footer'
import pagination from '@/components/pagination'
import notificationTop from '@/components/notificationTop'
import backToTop from '@/components/backToTop'
import checkinReceiveDialog from '@/components/checkinReceiveDialog'
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import {customSearchButtonClick,customTabClick} from '@/assets/js/sensors'

export default {
  data () {
    return {
      visibleShow: false,
      qrFocusChecked: false,
      dialogVisible: false,
      reminderShow:true,//控制移动端不显示
      cities:[],
      lineShow:false,
      hotShow:true,
      projectAreaShow:true,
      hotCity:'',
      ebsInvitatioExtList:[],
      epsPurchaseBulletinExtList:[],
      bidExtList:[],
      placeholderSearch:true,
      hitSearchUrl:'',
      navInfo: {},
      bannerInfo: {},
      titleObj: {name: '实时商机', eng: 'business opportunity'},
      businessList: [{title: '海南爱必侬物业管理有限公司物业保洁外包', time: '截止日期：2018-11-09 09:00'}, {title: '成都复地金融岛二期A2酒店木饰面工程招标公告', time: '截止日期：2018-11-09 09:00'}, {title: '复星FOLIDAY南站地块11、17地块工程全过程造价咨询', time: '截止日期：2018-11-09 09:00'}, {title: '复星地产上海公司\金豫兰庭二期\样板房精装修专业分包工程', time: '截止日期：2018-11-09 09:00'}, {title: '复星星泓安康天悦城项目2.1、2.2期（1#-40#楼及相应地下室）', time: '截止日期：2018-11-09 09:00'}, {title: '成都复地金融岛二期A2酒店木饰面工程招标公告', time: '截止日期：2018-11-09 09:00'}, {title: '复星FOLIDAY南站地块11、17地块工程全过程造价咨询', time: '截止日期：2018-11-09 09:00'}, {title: '复星地产上海公司\金豫兰庭二期\样板房精装修专业分包工程', time: '截止日期：2018-11-09 09:00'}, {title: '复星星泓安康天悦城项目2.1、2.2期（1#-40#楼及相应地下室）', time: '截止日期：2018-11-09 09:00'}],
      bannerInfo: {},
      webConfigInfo:{},
      paramInfo:{},
      supplierMenuList:{},
      inquiryBusinessList:{},
      inquiryBusinessTotal:0,
      tenderBusinessList:{},
      tenderBusinessTotal:0,
      winBiddingList:{},
      winBiddingTotal:0,
      newsInfo:{},
      bussiessType:2,
      currencyFlag:true,
      steelFlag:true,
      landFlag:true,
      travelFlag:true,
      currentPageTenderMore:2,
      currentPageInquiry:1,// 当前的页数
      currentPageInquiryMore:2,
      currentPageTender:1,// 当前的页数
      currentPageWinMore:2,
      currentPageWin:1,// 当前的页数
      currentSourceType:'',
      footerColumnInfos:[],
      navigationColumnInfos:[],
      noticeInfo:[],
      viewBussinessUrl:'',
      viewInquiryUrl:'',
      viewMessageUrl:'',
      ratationTime:undefined,
      searchKeyWord:'',
      selectBussinessType:2,
      selectNotice:'',
      keySearch:'',
      hitSearchUrl:'',
      enterpriseResourceBaseUrl:'',
      yellowPageColumn:{},
      productAndSolutionColumn:{},
      loading:true,
      sortLoading: false,
      tabName:"#tenderNnotice",
      customerPageUrl:'',
      userTag:'',
      categoryRadio:'',
      categoryCache:'',
      tenderPageSize:9,
      companyConfigUrl:'',
      tenderLoad:true,
      searchResult:false,
      noData:false,
      coordinationSupplierAuthFlag:'',
      coordinationSystemAuthFlag:'',
      supplierManagerAuthFlag:'',
      supplierManagerUrl:'',
      coordinationManagerUrl:'',
      coordinationSupplierUrl:'',
      recruitPurchaserUrl:'',
      recruitSupplierUrl:'',
      mroShoppingMallUrl:'',
      showNoticeInfo:false,
      qualificationsFileUrl:'',
      cancelShow:true,
      surveyVisible:false,
      userInfo:{},
      receiveDialogVisible: false, // 运营活动领取dialog
      sensorsCurrentSourceName: '',
      publishTime: true,// 招标公告排序-发布时间 0 升序  1降序 默认降序
      signEndTime: null,// 招标公告排序-截止时间 0 升序  1降序
//      leadSteps:{
//        firstStep:true,
//        secondStep:false,
//        thirdStep:false,
//        fourthStep:false,
//        fifthStep:false,
//        maskStep:false
//      }

    }
  },
  computed: mapState([
    'KP',
    'leadSteps'
  ]),
  components: {
    'v-header': header,
    'v-purchaserBanner': purchaserBanner,
    'v-dataCount': dataCount,
    'v-supplierLogged': supplierLogged,
    'v-notificationTop': notificationTop,
    'v-dynamicNews': dynamicNews,
    'v-topBar': topBar,
    'v-publiceTit': publiceTit,
    'v-businessList': businessList,
    'v-winBiddingList': winBiddingList,
    'v-enterpriseList': enterpriseList,
    'v-footer': footer,
    'v-tenderNoticeList': tenderNoticeList,
    'v-pagination': pagination,
    'v-backToTop': backToTop,
    'v-checkinReceiveDialog': checkinReceiveDialog

  },
  created () {
    if(this.getToken('isLogin') == 100){
      this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
      this.userTag = this.userInfo.userTag;

     this.dialogVisible = true;
      if((/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent))) {
          this.visibleShow = false;
      } else {
        // 登录后协议弹框
        if (this.getToken('privacyPolicyFlag') == 1) {
            this.visibleShow = true;
        } else {
          // 运营活动领取弹框-福星购
          if (this.getToken('supplierActivutyFxg') == 1) {
           this.fxgVisibleFn()
          }
          // else {
          //   // 满意度调查
          //   this.surveyVisibleFn();
          // }
        }
      }
    }
    let query = this.$route.query;
    this.searchKeyWord = query.searchKeyWord;
    this.selectNotice = this.searchKeyWord;
    this.selectBussinessType = query.bussiessType;
    if(query.sourceType){
      this.categoryRadio = query.sourceType;
    }

    if(/Android|webOS|iPhone|BlackBerry/i.test(navigator.userAgent)) {
      this.tenderPageSize = 10;
      this.reminderShow = false;
    } else {
      this.tenderPageSize = 9;
      this.reminderShow = true;
    }
    this.$axios.post('/onelink.mdata.main.api/supplierInfo/findSupplierMainInfo', {
      columnType: 2,
      positionType: 1,
      receiveObjects: 2,
      pageNo:1,
      pageSize:this.tenderPageSize,
      sourceType:query.sourceType,
      keywords:this.searchKeyWord,
      queryBids:'',
      accessToken:'',
      userTag:this.userTag,
      bussinessType:this.selectBussinessType
    }).then((res) => {
      this.loading=false;
      this.tenderLoad=false;
      this.data = res.data;
      this.supplierMenuList = res.data;
      this.ratationTime = Number(this.data.ratationTime)*1000;
      this.navigationColumnInfos = this.data.navigationColumnInfos;
      this.coordinationSupplierUrl = this.data.coordinationSupplierUrl;
      this.recruitPurchaserUrl = this.data.recruitPurchaserUrl;
      this.recruitSupplierUrl = this.data.recruitSupplierUrl;
      this.mroShoppingMallUrl = this.data.mroShoppingMallUrl;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.companyConfigUrl = this.data.companyConfigUrl;
      this.noticeInfo = this.data.noticeDtos;
      this.qualificationsFileUrl = this.data.qualificationsFileUrl;
      // this.coordinationSupplierAuthFlag = this.data.coordinationSupplierAuthFlag;
      this.footerColumnInfos = this.data.footerColumnInfos;
      this.bannerInfo = this.data.bannerPictureInfoDtos;
      this.paramInfo = this.data.paramInfoDto;
      this.webConfigInfo = res.data.webConfigInfoDto;
      this.newsInfo = res.data.bussinessInfo;
      this.inquiryBusinessList = res.data.bussinessInfo.inquiryNoticeInfo;
      if(this.selectBussinessType == 1){
        if(res.data.bussinessInfo.inquiryNoticeInfo){
          this.tenderLoad = false
        }
        if(!this.selectNotice){
          if(res.data.bussinessInfo.inquiryNoticeInfo.epsPurchaseBulletinExtList.length<=0){
            this.noData = true;
          }
        }else{
          this.keySearch = this.selectNotice
          if(res.data.bussinessInfo.inquiryNoticeInfo.epsPurchaseBulletinExtList.length<=0){
            this.searchResult = true;
          }
        }

      }

      this.inquiryBusinessTotal = Number(res.data.bussinessInfo.inquiryNoticeInfo.totalNumber);
      this.tenderBusinessList = res.data.bussinessInfo.tenderNoticeInfo;
      if(this.selectBussinessType == 2){
        if(res.data.bussinessInfo.tenderNoticeInfo){
          this.tenderLoad = false
        }
        if(!this.selectNotice){
          if(res.data.bussinessInfo.tenderNoticeInfo.ebsInvitatioExtList.length<=0){
            this.noData = true;
          }
        }else{
          this.keySearch = this.selectNotice
          if(res.data.bussinessInfo.tenderNoticeInfo.ebsInvitatioExtList.length<=0){
            this.searchResult = true;
          }
        }

      }

      this.tenderBusinessTotal = Number(res.data.bussinessInfo.tenderNoticeInfo.totalNumber);
      this.winBiddingList = res.data.bussinessInfo.winningNoticeInfo;
      if(this.selectBussinessType == 3){
        if(res.data.bussinessInfo.winningNoticeInfo){
          this.tenderLoad = false
        }
        if(!this.selectNotice){
          if(res.data.bussinessInfo.winningNoticeInfo.bidExtList.length<=0){
            this.noData = true;
          }
        }else{
          this.keySearch = this.selectNotice
          if(res.data.bussinessInfo.winningNoticeInfo.bidExtList.length<=0){
            this.searchResult = true;
          }
        }

      }

      this.winBiddingTotal = Number(res.data.bussinessInfo.winningNoticeInfo.totalNumber);
      this.viewBussinessUrl = res.data.viewBussinessUrl;
      this.viewInquiryUrl = res.data.viewInquiryUrl;
      this.viewMessageUrl =  res.data.viewMessageUrl;
      this.customerPageUrl = this.data.customerPageUrl;
      this.yellowPageColumn = this.data.yellowPageColumn;
      this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      this.supplierManagerUrl = this.data.supplierManagerUrl;
      this.coordinationManagerUrl = this.data.coordinationManagerUrl;
      this.coordinationSupplierAuthFlag = this.getToken('coordinationSupplierAuthFlag');
      this.coordinationSystemAuthFlag = this.getToken('coordinationSystemAuthFlag');
      this.supplierManagerAuthFlag = this.getToken('supplierManagerAuthFlag');
    }).catch((err) => {
        console.log(err)
    })
  },
  mounted () {
    document.title = "招标公告"
//    this.pagePosition();
    this.tabPosition();
    this.ulWidth();
    this.modalClickFn();
//    this.logOnAs();
    this.isLogin();
    this.filterActive();
    if (typeof(this.selectBussinessType) != "undefined") {
      this.bussiessType = this.selectBussinessType;
      $(window).scrollTop( $("#supplierEntryTab").offset().top )
      this.$forceUpdate();
    }

  },
  updated(){
    this.hasNotice();
  },
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    $route(to,from){
//      console.log(to.query.bussiessType);
      if(to.query.bussiessType == 1){
        this.projectAreaShow = false;
        this.currencyFlag=true;
        this.steelFlag=false;
        this.landFlag=false;
        this.travelFlag=false;
        this.placeholderSearch=true;
        this.tabName="#xbj";
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
        this.initBussinessInfo(to.query,1);
        this.pagePosition();
      }else if(to.query.bussiessType == 3){
        this.projectAreaShow = false;
        this.currencyFlag=true;
        this.steelFlag=true;
        this.travelFlag=true;
        // this.landFlag=false;
        this.landFlag=true;
        this.placeholderSearch=false
        this.tabName="#winTheBidding"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
        this.initBussinessInfo(to.query,3);
        this.pagePosition();
      }else if(to.query.bussiessType == 2){
        this.projectAreaShow = true;
        this.currencyFlag=true;
        this.steelFlag=true;
        this.landFlag=true;
        this.travelFlag=true;
        this.placeholderSearch=true
        this.tabName="#tenderNnotice"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
        this.initBussinessInfo(to.query,2);
        this.pagePosition();
      }else{
        this.projectAreaShow = true;
        this.currencyFlag=true;
        this.steelFlag=true;
        this.landFlag=true;
        this.travelFlag=true;
        this.placeholderSearch=true
        this.tabName="#tenderNnotice"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
        to.query.bussiessType = 2
        this.initBussinessInfo(to.query,2);
      }
      $('#myModal').modal('hide');
      this.filterActive();
    },
    currentPageWin(to,from){
      let winArr = [$('.winBiddingBottom')]
      winArr.forEach((item,index)=>{
        console.log(item)
        item.height('90px');
        item.siblings('.showBtn').css('display','block');
        item.siblings('.hideBtn').css('display','none');
      })
    },
    leadSteps:{
      handler(val, oldVal){
        if (this.getToken('supplierActivutyFxg') == 1){
          this.fxgVisibleFn()
        }
        // else {
        //   this.surveyVisibleFn();
        // }
        if(val.maskStep){
          this.logOnAs();
        }
      },
      deep:true
    }
  },
  methods: {
    // 招标公告排序
    sortList (type) {
      switch (type) {
        case 'publishTime':
          this.publishTime = !this.publishTime
          this.signEndTime = null
          this.pagechangeTender(1, this.publishTime, 'publishTime')
          break;
        case 'signEndTime':
          this.signEndTime = !this.signEndTime
          this.publishTime = null
          this.pagechangeTender(1, this.signEndTime, 'signEndTime')
          break;
      }
    },

    closeReceiveDialog () {
      this.receiveDialogVisible = false
      this.setToken('supplierActivutyFxg',0);
      // this.surveyVisibleFn();
    },
    closePrivacyPolicyDialog (isSure) {
      this.visibleShow = false;
      if (isSure == 1){
        this.fxgVisibleFn()
      }
    },
    closeDialog() {
      this.dialogVisible = false;
      this.visibleShow = false;
    },
    // 福星购是否显示
    fxgVisibleFn(){
      if(this.leadSteps.maskStep && (this.getToken('supplierActivutyFxg') == 1) && this.getToken('isLogin') == 100 && !(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent))){
        this.receiveDialogVisible=true;
      }else{
        this.receiveDialogVisible=false;
      }
    },
    initBussinessInfo(query,currentSelect){
      this.tenderLoad = true
      this.noData = false;
      this.searchResult = false;
      if(this.getToken('isLogin') == 100){
        this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
        this.userTag = this.userInfo.userTag;
      }
      this.searchKeyWord = query.searchKeyWord;
      this.selectNotice = this.searchKeyWord;
      this.selectBussinessType = query.bussiessType;
      this.$axios.post('/onelink.mdata.main.api/supplierInfo/findSupplierMainInfo', {
        columnType: 2,
        positionType: 1,
        receiveObjects: 2,
        pageNo:1,
        pageSize:9,
        sourceType:query.sourceType,
        keywords:this.searchKeyWord,
        queryBids:'',
        accessToken:'',
        userTag:this.userTag,
        bussinessType:currentSelect
      }).then((res) => {
        this.loading=false;
        this.data = res.data;
        this.supplierMenuList = res.data;
        this.ratationTime = Number(this.data.ratationTime)*1000;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.hitSearchUrl = this.data.hitSearchUrl;

        this.noticeInfo = this.data.noticeDtos;

        this.footerColumnInfos = this.data.footerColumnInfos;
        this.bannerInfo = this.data.bannerPictureInfoDtos;
        this.paramInfo = this.data.paramInfoDto;
        this.webConfigInfo = res.data.webConfigInfoDto;
        this.newsInfo = res.data.bussinessInfo;
        this.inquiryBusinessList = res.data.bussinessInfo.inquiryNoticeInfo;
        this.inquiryBusinessTotal = Number(res.data.bussinessInfo.inquiryNoticeInfo.totalNumber);
      if(this.selectBussinessType == 1){
        if(res.data.bussinessInfo.inquiryNoticeInfo){
          this.tenderLoad = false
        }
        if(!this.selectNotice){
          if(res.data.bussinessInfo.inquiryNoticeInfo.epsPurchaseBulletinExtList.length<=0){
            this.noData = true;
          }
        }else{
          this.keySearch = this.selectNotice
          if(res.data.bussinessInfo.inquiryNoticeInfo.epsPurchaseBulletinExtList.length<=0){
            this.searchResult = true;
          }
        }

      }
        this.tenderBusinessList = res.data.bussinessInfo.tenderNoticeInfo;
        this.tenderBusinessTotal = Number(res.data.bussinessInfo.tenderNoticeInfo.totalNumber);
      if(this.selectBussinessType == 2){
        this.tabName="#tenderNnotice"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
        if(res.data.bussinessInfo.tenderNoticeInfo){
          this.tenderLoad = false
        }
        if(!this.selectNotice){
          console.log(1)
          if(res.data.bussinessInfo.tenderNoticeInfo.ebsInvitatioExtList.length<=0){
            console.log(2)
            this.noData = true;
          }
        }else{
          this.keySearch = this.selectNotice
          if(res.data.bussinessInfo.tenderNoticeInfo.ebsInvitatioExtList.length<=0){
            this.searchResult = true;
          }
        }

      }
        this.winBiddingList = res.data.bussinessInfo.winningNoticeInfo;
        this.winBiddingTotal = Number(res.data.bussinessInfo.winningNoticeInfo.totalNumber);
      if(this.selectBussinessType == 3){
        if(res.data.bussinessInfo.winningNoticeInfo){
          this.tenderLoad = false
        }
        if(!this.selectNotice){
          if(res.data.bussinessInfo.winningNoticeInfo.bidExtList.length<=0){
            this.noData = true;
          }
        }else{
          this.keySearch = this.selectNotice
          if(res.data.bussinessInfo.winningNoticeInfo.bidExtList.length<=0){
            this.searchResult = true;
          }
        }

      }
        this.viewBussinessUrl = res.data.viewBussinessUrl;
        this.viewInquiryUrl = res.data.viewInquiryUrl;
        this.viewMessageUrl =  res.data.viewMessageUrl;
        this.customerPageUrl = this.data.customerPageUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
          console.log(err)
      })
    },
//    页面定位
    pagePosition(){
//      console.log($("#supplierEntry").offset())

        $("html, body").animate({
          scrollTop: $("#supplierEntry").offset().top-30 }, {duration: 500,easing: "swing"});
        return false;

    },
    tabPosition(){
      if(this.selectBussinessType == 1){
        this.projectAreaShow=false;
        this.placeholderSearch=true
        this.tabName="#xbj"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
      }else if(this.selectBussinessType == 3){
        this.projectAreaShow=false;
        this.placeholderSearch=false
        this.tabName="#winTheBidding"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
      }else{
        this.projectAreaShow=true;
        this.placeholderSearch=true;
        this.tabName="#tenderNnotice"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
      }
    },
    ulWidth () {
      // 动态计算ul的宽度
      let scrollwrap = $('#supplierEntryTab')
      let lis = $('li', scrollwrap)
      let sum = 0
      // 遍历每一个li元素
      lis.each(function (index, el) {
        let _el = $(el)
        // width 宽度 代表的是内容的宽度 innerWidth 代表的是padding + width
        // outerWidth 代表的是border+padding+width
        sum += _el.width()
      })
      // 将累加的值直接复制给ul元素
      scrollwrap.width(sum + 3)
    },
//    tab切换
    changeBussinessType(type){
      this.hotCity = '';
      this.lineShow=false;
      if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
        this.tenderPageSize = 10;
      } else {
        this.tenderPageSize = 9;
      }
      this.categoryRadio='',
      $('.conditionsList').children('li').removeClass("active");
      $('.conditionsList').children('li').eq(0).addClass("active");
      //切换公告
      this.bussiessType = type;
      if(type == 1){
        this.projectAreaShow = false;
        this.currencyFlag=true;
        this.steelFlag=false;
        this.landFlag=false;
        this.travelFlag=false;
      }
      if(type == 2){
        this.projectAreaShow = true;
        this.currencyFlag=true;
        this.steelFlag=true;
        this.landFlag=true;
        this.travelFlag=true;
      }
      if(type == 3){
        this.projectAreaShow = false;
        this.currencyFlag=true;
        this.steelFlag=true;
        this.travelFlag=true;
        // this.landFlag=false;
        this.landFlag=true;
      }
      this.currentSourceType = '';
      this.currentPageInquiry = 1;
      this.currentPageTender = 1;
      this.currentPageWin  = 1;
      //切换查询商机信息
      this.searchInitBussiness(this.bussiessType);

      // 埋点
      try {
        let tab_name;
        tab_name = type === 1 ? '询报价' : (type === 2 ? '招标公告' : '中标公示')
        customTabClick({
          position: "供应商",
          tab_name: tab_name
        })
      } catch (e) {console.log(e)}
    },
//    点击导航名企采购
    navChangeBussinessType(type){
      this.lineShow=false;
      this.selectNotice = "";
      this.$refs.noticeContent.value = "";
      if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
        this.tenderPageSize = 10;
      } else {
        this.tenderPageSize = 9;
      }
      this.categoryRadio='',
      $('.conditionsList').children('li').removeClass("active");
      $('.conditionsList').children('li').eq(0).addClass("active");
      //切换公告
      this.bussiessType = type;
      if(type == 1){
        this.currencyFlag=true;
        this.steelFlag=false;
        this.landFlag=false;
        this.travelFlag=false;
      }
      if(type == 2){
        this.currencyFlag=true;
        this.steelFlag=true;
        this.landFlag=true;
        this.travelFlag=true;
      }
      if(type == 3){
        this.currencyFlag=true;
        this.steelFlag=true;
        this.travelFlag=true;
        // this.landFlag=false;
        this.landFlag=true;
      }
      this.currentSourceType = '';
      this.currentPageInquiry = 1;
      this.currentPageTender = 1;
      this.currentPageWin  = 1;
      //切换查询商机信息
      this.searchInitBussiness(this.bussiessType);
    },
    moreChangeInquiry(){
      this.tenderPageSize = 5;
      this.currentPageInquiryMore = this.currentPageInquiryMore + 1;

      // ajax请求, 向后台发送 currentPage, 来获取对应的数据
      this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectBulletinListPage', {
        keywords: this.$refs.noticeContent.value,
        pageSize:this.tenderPageSize,
        pageNo:this.currentPageInquiryMore
      }).then((res) => {
        this.data = res.data;
      if(this.data.epsPurchaseBulletinExtList.length<=0){
        this.lineShow=true;
      }
        this.epsPurchaseBulletinExtList = this.data.epsPurchaseBulletinExtList;
        if(this.epsPurchaseBulletinExtList.length >0){
          this.epsPurchaseBulletinExtList.forEach(element =>{
            this.inquiryBusinessList.epsPurchaseBulletinExtList.push(element);
          })
        }
      }).catch((err) => {
          console.log(err)
      })
    },
    //分页查询询报价信息
    pagechangeInquiry(currentPage){
        this.currentPageInquiry = currentPage;
        // ajax请求, 向后台发送 currentPage, 来获取对应的数据
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectBulletinListPage', {
          keywords: this.$refs.noticeContent.value,
          pageSize:this.tenderPageSize,
          pageNo:currentPage
        }).then((res) => {
          this.inquiryBusinessList = res.data;
        }).catch((err) => {
            console.log(err)
        })
    },
    moreChangeTender(){
      this.tenderPageSize = 5;
      this.currentPageTenderMore = this.currentPageTenderMore  +1;

      // this.currentPageTender = this.currentPageTender + 1;
      // ajax请求, 向后台发送 currentPage, 来获取对应的数据
      this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectInvitatioListPage', {
        keywords: this.$refs.noticeContent.value,
        sourceType:this.categoryRadio,
        projectArea:this.hotCity,
        queryBids:'',
        accessToken:'',
        pageSize:this.tenderPageSize,
        pageNo:this.currentPageTenderMore
      }).then((res) => {
        this.data = res.data;
      if(this.data.ebsInvitatioExtList.length<=0){
        this.lineShow=true;
      }
        this.ebsInvitatioExtList =this.data.ebsInvitatioExtList;
        console.log(this.ebsInvitatioExtList);
//        alert(this.ebsInvitatioExtList.length);
        if(this.ebsInvitatioExtList.length >0){
          this.ebsInvitatioExtList.forEach(element =>{
            this.tenderBusinessList.ebsInvitatioExtList.push(element);
          })
        }
      }).catch((err) => {
          console.log(err)
      })
    },

    //分页查询招标公告信息
    pagechangeTender(currentPage, sortValue,sortKey){
        this.currentPageTender = currentPage;
        // ajax请求, 向后台发送 currentPage, 来获取对应的数据
        this.sortLoading = true
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectInvitatioListPage', {
          keywords: this.$refs.noticeContent.value,
          sourceType:this.currentSourceType,
          projectArea:this.hotCity,
          queryBids:'',
          accessToken:'',
          pageSize:this.tenderPageSize,
          pageNo:currentPage,
          sortKey: sortKey || null,
          sortValue: sortValue ? 1 : 0
        }).then((res) => {
          this.tenderBusinessList = res.data;
          this.sortLoading = false
        }).catch((err) => {
          this.sortLoading = false
          console.log(err)
        })
    },
    moreChangeWinning(){
      this.tenderPageSize = 5;
      this.currentPageWinMore = this.currentPageWinMore +1;
      // ajax请求, 向后台发送 currentPage, 来获取对应的数据
      this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectCmsAwardInvitatioListPage', {
        keywords: this.$refs.noticeContent.value,
        sourceType:this.categoryRadio,
        queryBids:'',
        pageSize:this.tenderPageSize,
        pageNo:this.currentPageWinMore
      }).then((res) => {
        this.data = res.data;
      if(this.data.bidExtList.length<=0){
        this.lineShow=true;
      }
        this.bidExtList = this.data.bidExtList;
        if(this.bidExtList.length >0){
          this.bidExtList.forEach(element =>{
            this.winBiddingList.bidExtList.push(element);
          })
        }
      }).catch((err) => {
          console.log(err)
      })
    },
    //分页查询中标公示信息
    pagechangeWinning(currentPage){
        this.currentPageWin = currentPage;
        // ajax请求, 向后台发送 currentPage, 来获取对应的数据
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectCmsAwardInvitatioListPage', {
          keywords: this.$refs.noticeContent.value,
          sourceType:this.currentSourceType,
          queryBids:'',
          pageSize:10,
          pageNo:currentPage
        }).then((res) => {
          this.winBiddingList = res.data;
        }).catch((err) => {
            console.log(err)
        })
    },
    //切换查询商机信息
    searchInitBussiness(sourceType){
      this.tenderLoad = true
      this.noData = false;
      this.searchResult = false;
      //询报价
      if(this.bussiessType == 1){
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectBulletinListPage', {
          keywords: this.$refs.noticeContent.value,
          pageSize:this.tenderPageSize,
          pageNo:this.currentPageInquiry
        }).then((res) => {
          this.tenderLoad = false
          this.inquiryBusinessList = res.data;
          this.inquiryBusinessTotal = Number(res.data.totalNumber);
        if(this.selectNotice){
          this.noData = false;
          if(res.data.epsPurchaseBulletinExtList.length<=0){
            this.keySearch = this.selectNotice;
            this.searchResult = true
          }else{
            this.searchResult = false
          }
        }else{
          this.searchResult = false
          if(res.data.epsPurchaseBulletinExtList.length<=0){
            this.noData = true;
          }else{
            this.noData = false;
          }
        }
        }).catch((err) => {
            console.log(err)
        })
      }

      //招标公告
      if(this.bussiessType == 2){
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectInvitatioListPage', {
          keywords: this.$refs.noticeContent.value,
          queryBids:'',
          accessToken:'',
          projectArea:this.hotCity,
          pageSize:this.tenderPageSize,
          pageNo:this.currentPageTender
        }).then((res) => {
          this.tenderLoad = false
          this.tenderBusinessList = res.data;
          this.tenderBusinessTotal = Number(res.data.totalNumber);
        if(this.selectNotice){
          this.noData = false;
          if(res.data.ebsInvitatioExtList.length<=0){
            this.keySearch = this.selectNotice;
            this.searchResult = true
          }else{
            this.searchResult = false
          }
        }else{
          this.searchResult = false
          if(res.data.ebsInvitatioExtList.length<=0){
            this.noData = true;
          }else{
            this.noData = false;
          }
        }
        }).catch((err) => {
            console.log(err)
        })
      }

       //中标公示
      if(this.bussiessType == 3){
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectCmsAwardInvitatioListPage', {
          keywords: this.$refs.noticeContent.value,
          queryBids:'',
          pageSize:10,
          pageNo:this.currentPageWin
        }).then((res) => {
          this.tenderLoad = false
          this.winBiddingList = res.data;
          this.winBiddingTotal = Number(res.data.totalNumber);
        if(this.selectNotice){
          this.noData = false;
          if(res.data.bidExtList.length<=0){
            this.keySearch = this.selectNotice;
            this.searchResult = true
          }else{
            this.searchResult = false
          }
        }else{
          this.searchResult = false
          if(res.data.bidExtList.length<=0){
            this.noData = true;
          }else{
            this.noData = false;
          }
        }
        }).catch((err) => {
            console.log(err)
        })
      }
    },
    //根据行业类别查询
    searchBussiness(bussiessType,sourceType,e, sourceName){
      // 新增为埋点需要
      this.sensorsCurrentSourceName = sourceName;

      this.currentPageTender = 1;
      this.currentPageInquiry = 1;
      this.currentPageWin = 1;
      this.tenderLoad = true
      this.searchResult = false
      this.noData = false
      if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
        this.tenderPageSize = 10;
      } else {
        this.tenderPageSize = 9;
      }
      if(e){
        $(e.target).addClass("active");
        $(e.target).siblings('li').removeClass("active");
        this.currentSourceType = sourceType;
      }else{
        this.currentSourceType = sourceType;
        if(this.bussiessType == 1){
          this.currencyFlag=true;
          this.steelFlag=false;
          this.landFlag=false;
          this.travelFlag=false;
          this.tabName="#xbj"
          $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
        }else if(this.bussiessType == 3){
          this.currencyFlag=true;
          this.steelFlag=true;
          this.travelFlag=true;
          // this.landFlag=false;
          this.landFlag=true;
          this.tabName="#winTheBidding"
          $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
        }else{
          this.currencyFlag=true;
          this.steelFlag=true;
          this.landFlag=true;
          this.travelFlag=true;
          this.tabName="#tenderNnotice"
          $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
        }

      }
      //询报价
      if(this.bussiessType == 1){
        this.inquiryBusinessList = {};
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectBulletinListPage', {
          keywords: this.$refs.noticeContent.value,
          pageSize:this.tenderPageSize,
          pageNo:this.currentPageInquiry
        }).then((res) => {
          this.inquiryBusinessList = res.data;
          this.inquiryBusinessTotal = Number(res.data.totalNumber);
        this.tenderLoad = false
        if(this.selectNotice){
          this.noData = false;
          if(res.data.epsPurchaseBulletinExtList.length<=0){
            this.keySearch = this.selectNotice;
            this.searchResult = true
          }else{
            this.searchResult = false
          }
        }else{
          this.searchResult = false
          if(res.data.epsPurchaseBulletinExtList.length<=0){
            this.noData = true;
          }else{
            this.noData = false;
          }
        }
//          if(!e){
//            this.filterActive();
//          }
        }).catch((err) => {
            console.log(err)
        })
      }

      //招标公告
      if(this.bussiessType == 2){
        this.tenderBusinessList = {};
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectInvitatioListPage', {
          keywords: this.$refs.noticeContent.value,
          sourceType:this.currentSourceType,
          projectArea:this.hotCity,
          queryBids:'',
          accessToken:'',
          pageSize:this.tenderPageSize,
          pageNo:this.currentPageTender
        }).then((res) => {
          this.tenderBusinessList = res.data;
          this.tenderBusinessTotal = Number(res.data.totalNumber);
          this.tenderLoad = false
          if(this.selectNotice){
            this.noData = false;
            if(res.data.ebsInvitatioExtList.length<=0){
              this.keySearch = this.selectNotice;
              this.searchResult = true
            }else{
              this.searchResult = false
            }
          }else{
            this.searchResult = false
            if(res.data.ebsInvitatioExtList.length<=0){
              this.noData = true;
            }else{
              this.noData = false;
            }
          }
//        if(!e){
//          this.filterActive();
//        }
        }).catch((err) => {
            console.log(err)
        })
      }

       //中标公示
      if(this.bussiessType == 3){
        this.winBiddingList = {};
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectCmsAwardInvitatioListPage', {
          keywords: this.$refs.noticeContent.value,
          sourceType:this.currentSourceType,
          queryBids:'',
          pageSize:10,
          pageNo:this.currentPageWin
        }).then((res) => {
          this.winBiddingList = res.data;
          this.winBiddingTotal = Number(res.data.totalNumber);
          this.tenderLoad = false
          if(this.selectNotice){
            this.noData = false;
            if(res.data.bidExtList.length<=0){
              this.keySearch = this.selectNotice;
              this.searchResult = true
            }else{
              this.searchResult = false
            }
          }else{
            this.searchResult = false
            if(res.data.bidExtList.length<=0){
              this.noData = true;
            }else{
              this.noData = false;
            }
          }
        }).catch((err) => {
            console.log(err)
        })
      }
    },
    //根据关键字查询不同公告信息
    searchContent(val){
      this.lineShow=false;
      this.tenderLoad=true;
      this.searchResult = false
      this.noData=false;
      if(val){
        this.selectNotice = val
      }
      if(this.$route.path!='/supplier'){
        if(this.$route.query.bussiessType){
          this.bussiessType = this.$route.query.bussiessType;
        }
        if(this.$route.query.sourceType){
          this.currentSourceType = this.$route.query.sourceType;
        }
      }

      if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
        this.tenderPageSize = 10;
      } else {
        this.tenderPageSize = 9;
      }
      //询报价
      if(this.bussiessType == 1){
        this.currentPageInquiry = 1;
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectBulletinListPage', {
          keywords: this.$refs.noticeContent.value,
          pageSize:this.tenderPageSize,
          pageNo:this.currentPageInquiry
        }).then((res) => {
          this.tenderLoad=false;
          this.inquiryBusinessList = res.data;
          if(this.selectNotice){
            this.noData = false;
            if(res.data.epsPurchaseBulletinExtList.length<=0){
              this.keySearch = this.selectNotice;
              this.searchResult = true
            }else{
              this.searchResult = false
            }
          }else{
            this.searchResult = false
            if(res.data.epsPurchaseBulletinExtList.length<=0){
              this.noData = true;
            }else{
              this.noData = false;
            }
          }
          this.inquiryBusinessTotal = Number(res.data.totalNumber);
        }).catch((err) => {
            console.log(err)
        })
      }

      //招标公告
      if(this.bussiessType == 2){
        this.currentPageTender = 1;
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectInvitatioListPage', {
          keywords: this.$refs.noticeContent.value,
          sourceType: this.currentSourceType,
          projectArea:this.hotCity,
          queryBids:'',
          accessToken:'',
          pageSize:this.tenderPageSize,
          pageNo:this.currentPageTender
        }).then((res) => {
          this.tenderLoad=false;
          this.tenderBusinessList = res.data;
        if(this.selectNotice){
          this.noData = false;
          if(res.data.ebsInvitatioExtList.length<=0){
            this.keySearch = this.selectNotice;
            this.searchResult = true
          }else{
            this.searchResult = false
          }
        }else{
          this.searchResult = false
          if(res.data.ebsInvitatioExtList.length<=0){
            this.noData = true;
          }else{
            this.noData = false;
          }
        }
          this.tenderBusinessTotal = Number(res.data.totalNumber);
        }).catch((err) => {
            console.log(err)
        })
      }

       //中标公示
      if(this.bussiessType == 3){
        this.currentPageWin = 1;
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectCmsAwardInvitatioListPage', {
          keywords: this.$refs.noticeContent.value,
          sourceType: this.currentSourceType,
          queryBids:'',
          pageSize:10,
          pageNo:this.currentPageWin
        }).then((res) => {
          this.tenderLoad=false;
          this.winBiddingList = res.data;
          if(this.selectNotice){
            this.noData = false;
            if(res.data.bidExtList.length<=0){
              this.keySearch = this.selectNotice;
              this.searchResult = true
            }else{
              this.searchResult = false
            }
          }else{
            this.searchResult = false
            if(res.data.bidExtList.length<=0){
              this.noData = true;
            }else{
              this.noData = false;
            }
          }
          this.winBiddingTotal = Number(res.data.totalNumber);
        }).catch((err) => {
            console.log(err)
        })
      }

      // 埋点
      try {
        customSearchButtonClick({position: "招标公告下商机搜索"})
      } catch (e) {
        console.log(e)
      }
    },
    //      导航搜索
    navSearchContent(val){
      this.bussiessType = val.bussiessType;
      this.selectBussinessType = val.bussiessType;
      this.$refs.noticeContent.value = val.keyword;
      this.selectNotice = val.keyword;
      this.currentSourceType = '';
      this.tabPosition();
      this.categoryRadio='',
        $('.conditionsList').children('li').removeClass("active");
      $('.conditionsList').children('li').eq(0).addClass("active");
      this.searchContent(val.keyword);
    },
    //      条件搜索
    conditionsSearchContent(val){
      this.bussiessType = val.bussiessType;
      this.selectBussinessType = val.bussiessType;
      this.$refs.noticeContent.value = val.keyword;
      this.selectNotice = val.keyword;
      if(val.bussiessType == 1){
        this.currencyFlag=true;
        this.steelFlag=false;
        this.landFlag=false;
        this.travelFlag=false;
        this.tabName="#xbj"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
      }else if(val.bussiessType == 3){
        this.currencyFlag=true;
        this.steelFlag=true;
        this.travelFlag=true;
        // this.landFlag=false;
        this.landFlag=true;
        this.tabName="#winTheBidding"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
      }else{
        this.currencyFlag=true;
        this.steelFlag=true;
        this.landFlag=true;
        this.travelFlag=true;
        this.tabName="#tenderNnotice"
        $('#supplierEntryTab a[href="'+this.tabName+'"]').tab('show');
      }
      this.$nextTick(function () {
        if(val.sourceType == '000000'){
          $('.conditionsList').children('li').removeClass("active");
          $('.conditionsList').children('li').eq(1).addClass("active");
        }else if(val.sourceType == 'INV0002'){
          $('.conditionsList').children('li').removeClass("active");
          $('.conditionsList').children('li').eq(2).addClass("active");
        }else if(val.sourceType == 'INV0001'){
          $('.conditionsList').children('li').removeClass("active");
          $('.conditionsList').children('li').eq(3).addClass("active");
        }
      })

      this.tabPosition();
      this.changeBussinessType(val.bussiessType);
      this.searchBussiness(val.bussiessType,val.sourceType);
    },
    changeViewNumber(val){
      this.newsInfo.viewNumber = val;
    },
//    移动端打开分类弹框
    showModal(){
      this.categoryCache=this.categoryRadio;
    },
//    移动端弹框确认按钮
    confirmClass(){
      this.lineShow=false;
      this.searchBussiness(this.bussiessType,this.categoryRadio);
      $('#classModal2').modal('hide');
      $('#classModal3').modal('hide');
    },
//    移动端tab切换变换按钮
    tabChange(val){
      this.cancelShow=val;
    },
//    移动端弹框取消按钮
    cancelClass(){
//      this.getHotCity();
      $('#classModal2').modal('hide');
      $('#classModal3').modal('hide');
      this.categoryRadio=this.categoryCache;
    },
//    移动端弹框重置按钮
    resetClass(){
      this.hotCity = '';
      this.getHotCity();
      $('#classModal2').modal('hide');
      $('#classModal3').modal('hide');
      this.categoryRadio=this.categoryCache;
    },
//    模态框关闭事件
    modalClickFn(){
      $('#classModal2').on('click', (e) => {
        if(e.target.id=='classModal2'){
          this.cancelClass();
        }
      })
    },
    filterActive(){
      if(this.$route.query.bussiessType == 2){
        if(this.$route.query.sourceType){
          if(this.$route.query.sourceType == '000000'){
            $('.conditionsList').children('li').removeClass("active");
            $('.conditionsList').children('li').eq(1).addClass("active");
          }else if(this.$route.query.sourceType == 'INV0002'){
            $('.conditionsList').children('li').removeClass("active");
            $('.conditionsList').children('li').eq(2).addClass("active");
          }else if(this.$route.query.sourceType == 'INV0001'){
            $('.conditionsList').children('li').removeClass("active");
            $('.conditionsList').children('li').eq(3).addClass("active");
          }
        }else{
          $('.conditionsList').children('li').removeClass("active");
          $('.conditionsList').children('li').eq(0).addClass("active");
        }
      }else if(this.$route.query.bussiessType == 1){
        if(this.$route.query.sourceType){
          if(this.$route.query.sourceType == '000000'){
            $('.conditionsList').children('li').removeClass("active");
            $('.conditionsList').children('li').eq(1).addClass("active");
          }else if(this.$route.query.sourceType == 'INV0002'){
            $('.conditionsList').children('li').removeClass("active");
            $('.conditionsList').children('li').eq(2).addClass("active");
          }else if(this.$route.query.sourceType == 'INV0001'){
            $('.conditionsList').children('li').removeClass("active");
            $('.conditionsList').children('li').eq(3).addClass("active");
          }
        }else{
          $('.conditionsList').children('li').removeClass("active");
          $('.conditionsList').children('li').eq(0).addClass("active");
        }
      }else if(this.$route.query.bussiessType == 3){
        if(this.$route.query.sourceType){
          if(this.$route.query.sourceType == '000000'){
            $('.conditionsList').children('li').removeClass("active");
            $('.conditionsList').children('li').eq(1).addClass("active");
          }else if(this.$route.query.sourceType == 'INV0002'){
            $('.conditionsList').children('li').removeClass("active");
            $('.conditionsList').children('li').eq(2).addClass("active");
          }else if(this.$route.query.sourceType == 'INV0001'){
            $('.conditionsList').children('li').removeClass("active");
            $('.conditionsList').children('li').eq(3).addClass("active");
          }
        }else{
          $('.conditionsList').children('li').removeClass("active");
          $('.conditionsList').children('li').eq(0).addClass("active");
        }
      }
    },
    //    判断是否从登陆页跳转过来
    isLogin(){
      if(this.$route.query.shortcutMenu){
        this.logOnAs();
      }else{
        if(this.leadSteps.maskStep){
          this.pagePosition();
        }
      }
    },
//    判断是否登录及登录身份 10供应商  20采购商
    logOnAs(){
      if(this.getToken('isLogin') == 100){
        let userTag = this.userInfo.userTag;
        if(userTag == '10' && this.leadSteps.maskStep){
          $("html, body").animate({
            scrollTop: $(".purchaserLogged").offset().top-48 }, {duration: 500,easing: "swing"});
          return false;
        }
      }
    },
    //      判断是否有公告通知
    hasNotice(){
//      console.log('11')
//      console.log(Cookies.get('noticeLength'))
//      console.log(JSON.parse(this.getToken('noticeInfosExt')))
      if(this.getToken('isLogin') == 100){
//        console.log(JSON.parse(this.getToken('noticeInfos')))
        if(JSON.parse(this.getToken('noticeInfos'))){
          if(JSON.parse(this.getToken('noticeInfos')).length>0){
//            console.log('you');
            this.showNoticeInfo = true;
          }else{
            this.showNoticeInfo = false;
          }
        }else{
          this.showNoticeInfo = false;
        }
      }else{
        if(Cookies.get('noticeLength') != 0){
          this.showNoticeInfo = true;
        }else{
          this.showNoticeInfo = false;
        }
      }

    },
    moreCity(){
      this.hotShow = false;
    },
    moreCityHide(){
      this.hotShow = true;
    },
    getPositionCity(val){
      this.cities = [];
      this.$axios.post('/onelink.mdata.main.api/region/getCities', {
        provinceCode:val
      }).then((res) => {
        this.cities = res.data;
      }).catch((err) => {
          console.log(err)
      })
    },
    getHotCity(val){
      this.currentPageTender = 1;
      this.tenderBusinessList = {};
      this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectInvitatioListPage', {
        keywords: this.$refs.noticeContent.value,
        sourceType:this.currentSourceType,
        projectArea:this.hotCity,
        queryBids:'',
        accessToken:'',
        pageSize:this.tenderPageSize,
        pageNo:this.currentPageTender
      }).then((res) => {
        this.tenderBusinessList = res.data;
        this.tenderBusinessTotal = Number(res.data.totalNumber);
        this.tenderLoad = false
        if(this.selectNotice){
          this.noData = false;
          if(res.data.ebsInvitatioExtList.length<=0){
            this.keySearch = this.selectNotice;
            this.searchResult = true
          }else{
            this.searchResult = false
          }
        }else{
          this.searchResult = false
          if(res.data.ebsInvitatioExtList.length<=0){
            this.noData = true;
          }else{
            this.noData = false;
          }
        }
  //        if(!e){
  //          this.filterActive();
  //        }
      }).catch((err) => {
          console.log(err)
      })
    },
    mobileGetCity(val){
      this.getPositionCity(val);
    },
    cityClose(){
      this.hotCity = '';
      this.getHotCity();
    }
    //问卷调研是否显示
    // surveyVisibleFn(){
    //   if(this.leadSteps.maskStep && (this.getToken('isOperateQuestionNaire') !== '' && this.getToken('isOperateQuestionNaire') == 0) && this.getToken('isLogin') == 100 && !(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent))){
    //     this.surveyVisible=true;
    //   }else{
    //     this.surveyVisible=false;
    //   }
    // },
    // //    调研弹框事件
    // surveyFn(){
    //   this.surveyDialogFn(false);
    // },
    // surveyDialogFn(val){
    //   this.surveyVisible=false;
    //   this.$axios.post('/onelink.mdata.main.api/web/operateQuestionNaire', {
    //   }).then((res)=>{
    //     if(res.data.code == 0){
    //       if(val){
    //         this.setToken('isOperateQuestionNaire',1);
    //           window.location.href="https://www.lediaocha.com/pc/s/3z2vdjx3";
    //         // window.location.href="https://www.lediaocha.net/pc/s/23zpo8mn"
    //       }else{
    //         this.setToken('isOperateQuestionNaire',1);
    //       }
    //     }
    //   })
    // }
  }
}
</script>

<style>
  #supplier .custom-dialog .el-dialog {
    width: 480px;
    height: 338px;
  }

  #supplier .custom-dialog .content {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    padding: 0 10px;
  }

  #supplier .custom-dialog .content .left .p1 {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #303133;
    font-weight: 600;
  }
  #supplier .custom-dialog .content .left .p2 {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #606266;
  }

  #supplier .custom-dialog .content .right .qr {
    width: 120px;
    height: 120px;
    background: purple;
  }

  #supplier .custom-dialog .content .right .qr-scan {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #A8ACB2;
    line-height: 12px;
    margin-top: 5px;
    text-align: center;
  }
  #supplier .custom-dialog .footer {
    background: #fff;
    text-align: center;
    line-height: 32px;
  }

  #supplier .custom-dialog .footer .know {
    width: 120px;
    height: 32px;
    background: #3F88E0;
    color: #fff;
    text-align: center;
    margin: 0 auto;
  }

  #supplier .custom-dialog .footer .el-checkbox {
    margin-top: 15px;
  }

  #supplier .custom-dialog .footer .el-checkbox__label {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #A8ACB2;
  }

  #supplier .rule-dialog .el-dialog__footer {
    text-align: center;
  }

  #supplier .sort-icon-normal, .sort-icon-down, .sort-icon-up{
    display: inline-block;
    vertical-align: middle;
    width: 12px;
    height: 12px;
    background: url('http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/sort_icon_normal.svg');
  }
  #supplier .sort-icon-up{
    background: url('http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/sort_icon_up.svg');
  }
  #supplier .sort-icon-down {
    background: url('http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/sort_icon_down.svg');
  }
  #supplier .conditionsList .active-sort-txt{
    color: #3F88E0;
  }
  #supplier .shor-container{
    position: relative;
    width: 20px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/supplier/index.vue